import { useQuery } from "@tanstack/react-query"
import { makeGetKnowledgeBases } from "../../domain/use-cases/get-knowledge-bases"
import { httpKnowledgeBaseRepository } from "../../data/repositories/knowledge-base-repository"

const getKnowledgeBases = makeGetKnowledgeBases(httpKnowledgeBaseRepository)

type Params = { page: number; limit: number; name?: string }

export const useKnowledgeBases = (params: Params) =>
  useQuery({
    queryKey: ["knowledge-bases", params],
    queryFn: () => getKnowledgeBases(params),
  })
